import React from 'react';

const getSkillsIcon = (skill_slug: string): JSX.Element => {
  let src = "";

  switch (skill_slug) {
    default:
    case 'critical_thinking':
      src = "/PuzzleSolver.svg";
      break;
    case 'creativity':
      src = "/CreativeSpark.svg";
      break;
    case 'growth_mindset':
      src = "/BrainBuilder.svg";
      break;
    case 'collaboration':
      src = "/SyncSquad.svg";
      break;
    case 'communication':
      src = "/SignalBoost.svg";
      break;
    case 'global_citizenship':
      src = "/WorldCitizen.svg";
      break;
  }

  return (
      <img src={src} alt={skill_slug} className="skills_img"/>
  );
}

export default getSkillsIcon;